export default __webpack_public_path__ + "static/media/chip_25.78590829.svg";